module.exports = __webpack_public_path__ + "static/media/Other-Winter-apple.17c78c96.jpg";